<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('detail')"></pageTitle>
        <myDetailCell :info="labels" :title="$t('page_title.Sending_mail_info')"></myDetailCell>
        <Row justify="end" class="mg-top20">
          <Col>
            <Button class="mg-right20" @click="$base.linkBack()">{{ $t("back") }}</Button>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import myDetailCell from "@/components/myDetailCell";
import pageTitle from "@/components/pageTitle";
export default {
  name: "recruit_detail",
  components: {
    myDetailCell,
    pageTitle
  },
  data () {
    return {
      id: this.$base.getRequest().id,
      labels: [],
      info: {},
    };
  },
  mounted () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.$base.showLoading();
      this.$request.sendPost(
        "mailinfo/log/before-upd",
        { log_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.info = data;
          this.labels = [
            { label: this.$t("cms_email.addTime"), value: this.info.add_time },
            { label: this.$t("cms_email.name"), value: this.info.subject },
            { label: this.$t("cms_email.send_user"), value: this.info.send_users },
            { label: this.$t("cms_email.org_cname"), value: this.info.org_cname },
            { label: this.$t("cms_email.mail_dear"), value: this.info.mail_dear },
            { label: this.$t("cms_email.title"), value: this.info.title },
            { label: this.$t("cms_email.content"), value: this.info.content },
            { label: this.$t("cms_email.mail_end"), value: this.info.mail_end },
          ];
        }
      );
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .datum {
    .datum_item {
      display: flex;
      padding: 10px 0;
      .name {
        margin-right: 10px;
        font-weight: bold;
      }
    }
  }
  .demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .tablelist {
    padding: 10px 0;
  }
}

.salary {
  padding-left: 8px;
  display: flex;
  align-items: center;
}
.hkd {
  margin-top: 1px;
}
.hide_input {
  position: absolute;
  top: -500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/email/record/record_detail.vue